module.exports = __webpack_public_path__ + "img/Launch-Admin-Logo-Colour.810fbe31.svg";